import { gql, type OperationVariables } from '@apollo/client';
import type IOpportunity from '@sharedInterfaces/IOpportunity';
import type { IOpportunityEdit } from '@sharedInterfaces/IOpportunity';
import Opportunity from '@src/Objects/Opportunity';

import GraphQL from '../graphQL';

import { opportunityGql } from './getOpportunity';

const query = gql`
mutation editOpportunity($changedOpportunity:OpportunityEdit!) {
    editOpportunity(changedOpportunity: $changedOpportunity) 
    ${opportunityGql}
},
`;

export default async function editOpportunity(changedOpportunity: IOpportunityEdit): Promise<Opportunity> {
    const variables: OperationVariables = {
        changedOpportunity: {
            ...changedOpportunity,
            type: undefined,
            createdBy: undefined,
            changedBy: undefined,
            createdAt: undefined,
            changedAt: undefined,
            roles: changedOpportunity.roles.map((role) => ({ id: role.id, title: role.title })),
            primaryRole: changedOpportunity.primaryRole
                ? { id: changedOpportunity.primaryRole.id, title: changedOpportunity.primaryRole.title }
                : null,
            // Filter out role fields from selectedEmployees as they're not in EmployeeCoverageInput
            selectedEmployees: changedOpportunity.selectedEmployees.map((emp) => ({
                id: emp.id,
                title: emp.title,
                score: emp.score,
                skillCoverage: emp.skillCoverage,
                coveredSkills: emp.coveredSkills,
                missingSkills: emp.missingSkills,
                coveredCertificates: emp.coveredCertificates,
                missingCertificates: emp.missingCertificates,
                // Exclude missingRoles and coveredRoles
            })),
        },
    };
    return GraphQL.mutate<IOpportunity>(query, variables).then((result) => new Opportunity(result));
}
